// Vendor
import $ from 'jquery';
import Helper from '../helpers/util';
import PageTracker from './PageTracker';
import { TweenLite } from 'gsap';
class TileSlider {
	constructor(el) {
		this.$el = $(el);
		this.slidesPerView = this.$el.data('slides-per-view') || 3;
		this.slidesPerViewMd = this.$el.data('slides-per-view-md') || 3;
		this.$track = this.$el.find('.elp-tile-slider__track');
		this.$slides = this.$el.find('.elp-tile-slider__slide');

		this.$resource = this.$el.find('.card-elp-resource');

		this.$outer = this.$el.find('.scroll-carousel-outer');
		this.$item = this.$el.find('.scroll-carousel-inner > div');
		this.$scroll = this.$el.find('> div');

		this.clsHidden = 'hidden';
		this.curDown = false;
		this.curYPos = 0;
		this.curXPos = 0;
		this.stepW = 0;

		this.$controls = this.$el.find('.nav-carousel__controls');

		if (this.$controls.length) {
			this.controlsEvents();
		}

		// Track click download/print

		if (this.$track.length) {
			this.updatePadding();
			this.attachEvents();
		}

		this.$el.data('init', true);
	}

	setSteps() {
		this.steps = [0];

		this.$item.each((i, el) => {
			const offsetLeft = el.offsetLeft;
			const clientWidth = el.clientWidth;
			const step = offsetLeft + clientWidth;
			this.steps.push(step);
		});

		// hide or show controls
		const outer = (step) => {
			return step > this.$outer.width();
		};

		const $arrows = this.$controls.find('.controls-arrow');

		if (!this.steps.some(outer)) {
			$arrows.addClass('hidden');
		} else {
			$arrows.removeClass('hidden');
		}
	}

	controlsEvents() {
		Helper.pubsub.subscribe('onWindowResize', () => {
			this.setSteps();
		});

		const $arrows = this.$controls.find('.controls-arrow');
		$arrows.on('click', (evt) => {
			this.controlsClickHandler(evt);
		});
	}

	controlsClickHandler(evt) {
		const $element = $(evt.currentTarget);
		const direction = $element.hasClass('controls-arrow--right')
			? 'next'
			: 'prev';

		const currentX = this.$outer.scrollLeft();
		let scrollX;
		if (direction === 'next') {
			scrollX = this.steps.find((v) => v > currentX);
		} else {
			scrollX = this.steps[this.steps.findIndex((v) => v >= currentX) - 1];
		}

		TweenLite.to(this.$outer, 0.5, { scrollTo: { x: scrollX } });
		this.stepW = scrollX;
	}

	attachEvents() {
		// on resize adjust the "peek" amount
		window.addEventListener('resize', () => {
			this.updatePadding();
			this.setSteps();
		});

		window.addEventListener('load', () => {
			this.setSteps();
		});

		if (this.$resource.length) {
			this.$link = this.$resource.find('.card__action-icon');

			this.$link.each((i, button) => {
				button.addEventListener('click', (e) => {
					PageTracker($(button).attr('data-track'));
				});
			});
		}
	}

	updatePadding() {
		const gutter =
			(window.innerWidth -
				this.$el.find('.container-fluid').first().innerWidth()) /
				2 +
			20;
		this.$slides.first().css({ marginLeft: gutter });
		this.$slides.last().css({ paddingRight: gutter });

		const containerWidth =
			this.$el.find('.container-fluid').first().width() + 10;
		const slides =
			window.innerWidth >= 1024
				? this.slidesPerView
				: window.innerWidth > 600
				? this.slidesPerViewMd
				: 1;
		const slideWidth = containerWidth / slides - 10;
		//console.log(containerWidth, slides, slideWidth);
		this.$slides.css({ width: slideWidth });
		this.$slides.last().css({ width: slideWidth + gutter });

		this.$controls.css({ right: gutter });
	}
}

const _init = () => {
	// Elements
	let $el = $('.elp-tile-slider');
	if ($el.length) {
		$el.each((e, v) => {
			if (!$(v).data('init')) {
				new TileSlider($(v));
			}
		});
	}
};

_init();
Helper.pubsub.subscribe('initComponents', function () {
	_init();
});
